import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { settingsAPI } from '../services/settingsAPI';

export const useSiteSettings = () => {
  const { token } = useAuth();
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const data = await settingsAPI.getAll(token);
        
        // Convertir le tableau en objet pour un accès plus facile
        const settingsObj = {};
        data.settings.forEach(setting => {
          settingsObj[setting.setting_key] = setting.setting_value;
        });
        
        setSettings(settingsObj);
        setError(null);
      } catch (err) {
        console.error('Error fetching site settings:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [token]);

  // Fonction pour obtenir un paramètre avec fallback
  const getSetting = (key, fallback = '') => {
    return settings[key] || fallback;
  };

  // Fonction pour obtenir un paramètre localisé
  const getLocalizedSetting = (baseKey, fallbackKey = '') => {
    const currentLang = localStorage.getItem('language') || 'fr';
    const localizedKey = `${baseKey}_${currentLang}`;
    return settings[localizedKey] || fallbackKey;
  };

  // Fonction pour obtenir un paramètre de navigation
  const getNavSetting = (navKey) => {
    const currentLang = localStorage.getItem('language') || 'fr';
    const key = `nav_${navKey}_${currentLang}`;
    return settings[key] || navKey;
  };

  // Fonction pour obtenir un paramètre de page
  const getPageSetting = (pageKey, settingKey) => {
    const currentLang = localStorage.getItem('language') || 'fr';
    const key = `${pageKey}_${settingKey}_${currentLang}`;
    return settings[key] || settingKey;
  };

  return {
    settings,
    siteSettings: settings,
    loading,
    error,
    getSetting,
    getLocalizedSetting,
    getNavSetting,
    getPageSetting,
    setSiteSettings: setSettings
  };
};
